/*
 * Copyright (c) 2024 Ask Sage, Inc. All rights reserved.
 * This software is the confidential and proprietary information of Ask Sage, Inc.
 * You shall not disclose such confidential information and shall use it only in
 * accordance with the terms of the license agreement you entered into with Ask Sage, Inc.
 * THIS SOFTWARE IS PROVIDED "AS IS" AND ANY EXPRESSED OR IMPLIED WARRANTIES,
 * INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND
 * FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL ASK SAGE, INC.
 * OR ITS CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
 * EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT
 * OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
 * INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT,
 * STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY
 * OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 * You may not use this software except in compliance with the License.
 * You may not modify, reverse engineer, or redistribute this software.
 */
import { Button, Dialog, DialogContent, DialogTitle, DialogActions, Alert } from '@mui/material';
import React from 'react';

const ShareChat = ({
  open,
  onClose,
  isShareButtonDisabled, 
  handleSubmit,
  chatName, 
  errorMessage,
  successMessage,
  inputShareRef,
  newShareEmail,
  currentShareKey,
  setNewShareEmail
}) => {

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Share the Chat "{chatName}" to:</DialogTitle>
      <DialogContent>
        <Alert severity='info' sx={{mb:2}}>Make sure the user has an existing Ask Sage account with that email, that the email is from the same domain as yours, and has proper need to know for this information</Alert>
        <form className="form" onSubmit={handleSubmit}>
          <input type="hidden" value={currentShareKey} name="currentShareKey"></input>
          <span className="edit-label">Share to Email(*)</span>
          <input 
            className="edit-input" 
            value={newShareEmail} 
            ref={inputShareRef}
            onChange={(e)=> setNewShareEmail(e.target.value)}
            type="text"
            name="new_email"
          />
          <br />
          <br />
          {errorMessage && <p style={{ color: 'red' }}>{errorMessage}</p>}
          {successMessage && <p style={{ color: 'green' }}>{successMessage}</p>}
        </form>
      </DialogContent>
      <DialogActions>
        <Button 
          variant={'contained'} 
          color={'primary'} 
          onClick={handleSubmit}
          disabled={isShareButtonDisabled}
        >
          Share
        </Button>
        <Button color={'error'} onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>            
  );
};

export default ShareChat;
